import request from '@/config/axios'

export const CatalogPublishScopeApi = {
  getTree: async (serviceId: number) => {
    return await request.get({ url: '/o2o/catalog/publish-scope/tree?serviceId=' + serviceId })
  },
  batchSave: async (data: {
    serviceId: number
    selections: {
      cityId: number
      categoryId?: number
      serviceId?: number
      checked: boolean
      scopeStatus?: string
    }[]
  }) => {
    return await request.put({ url: '/o2o/catalog/publish-scope/batch', data })
  }
}
